export default __webpack_public_path__ + "static/contract-templates-1-3959b8cff44186dcd89a3b918447180d.jpeg";